import { CurrentPageInputFieldProps } from "../../types";

export const CurrentPageInputField = ({
  pageInput,
  handleChangeOnInput,
  handleBlurOnInput,
}: CurrentPageInputFieldProps) => {
  return (
    <div className="flex flex-col items-start justify-start flex-grow-0 flex-shrink-0 w-14">
      <div className="flex flex-col items-start self-stretch justify-start flex-grow-0 flex-shrink-0 gap-1 ">
        <input
          className="border border-lineDark flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-1.5 px-3  py-1 rounded bg-bgWhite dark:bg-secondaryLight dark:text-textMain focus:border-2 focus:border-primary focus:outline-none dark:border-lineLight"
          value={pageInput}
          onChange={handleChangeOnInput}
          onBlur={handleBlurOnInput}
        />
      </div>
    </div>
  );
};
